import { Outcome } from '../@types';
import { useIsOutcomeSelected } from '../stores/betslip/selectors';

export const useEventCardOutcomeCell = (outcome: Outcome) => {
  const selected = useIsOutcomeSelected(outcome.id);
  const disabled = Number(outcome.odds) <= 1;

  return { selected, disabled };
};
